import React, { FC } from 'react';
// import './layout.scss';

type Props = {
  children: React.ReactNode;
}

const Layout: FC<Props> = ({ children }) => {

  return (
    <div>
      {children}
    </div>
  );
}


export default Layout;
